import { BaseEntity } from "yt-ng-framework";

export class KomitentView extends BaseEntity{
    constructor(){
        super();
    }

    Naziv: string;
    SNaziv: string;
    Pib: string;
    MaticniBroj: string;
    Adresa: string;
    Mesto: string;
    Jbkjs: string;
    ZaCrf: boolean = false;
    Jmbg:string;
    PibJmbg: string;
    is_active: boolean = true;
    PostBroj:string;
    Gln:string;

    Deserialize(input: any){
        this.ID = input.ID;
        this.Naziv = input.Naziv;
        this.SNaziv = input.SNaziv;
        this.Pib = input.Pib;
        this.MaticniBroj = input.MaticniBroj;
        this.Adresa = input.Adresa;
        this.Mesto = input.Mesto;
        this.Jbkjs = input.Jbkjs;
        this.ZaCrf=input.ZaCrf;
        this.Jmbg=input.Jmbg;
        this.PibJmbg = input.PibJmbg;
        this.is_active = input.is_active;
        this.PostBroj=input.PostBroj;
        this.Gln=input.Gln;
        return this;
    }

    Serialize(input: KomitentView){
        return input;
    }
}
